module.exports = __webpack_public_path__ + "img/hip-endo-mesomorph-female.39632b54.svg";